import React, { memo } from 'react';
import log from 'loglevel';
import { css } from 'linaria';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { styled } from 'linaria/react';
import { FooterList } from '../footer-list';
import { selectCurrentRegion } from '../../selectors';
import { ModelJsonStore, SubscriptionStore } from '../../reducers';
import { FooterAppBlock, FooterAppBlockDesktop } from '../footer-app-block';
import { FooterSubscribe } from '../footer-subscribe/footer-subscribe';
import { FooterSocialLinks } from '../footer-social-links/footer-social-links';

export const logParam = (param: string) => log.error(`${param} не получен`);

export const Footer: React.FC = memo(() => {
  const { model } = useStoreon<ModelJsonStore>('model');
  const { subscribersApiKey, subscribersUrl, recaptchaPublicKey } = useStoreon<SubscriptionStore>(
    'subscribersApiKey',
    'subscribersUrl',
    'recaptchaPublicKey'
  );

  if (!subscribersApiKey) logParam('subscribersApiKey');
  if (!subscribersUrl) logParam('subscribersUrl');
  if (!recaptchaPublicKey) logParam('recaptchaPublicKey');

  const currentRegion = selectCurrentRegion(model?.regions, model?.properties?.regionId);

  if (!model?.footer || !currentRegion) return null;

  return (
    <div data-qa="footer-content">
      <FooterAppBlock />
      <FooterLayout>
        <Layout className={footer}>
          <UpperFooter>
            <FooterList footer={model.footer} />
            <FooterAppBlockDesktop footer={model.footer} />
          </UpperFooter>
          <FooterSubscribe
            footer={model.footer}
            subscribersUrl={subscribersUrl}
            subscribersApiKey={subscribersApiKey}
            recaptchaPublicKey={recaptchaPublicKey}
          />
          <FooterSocialLinks footer={model.footer} />
        </Layout>
      </FooterLayout>
    </div>
  );
});

const FooterLayout = styled.div`
  background: var(--background-accent);
`;

const UpperFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const footer = css`
  display: flex;
  flex-direction: column;
  padding-top: var(--space-400);
  padding-bottom: var(--space-500);
  @media (--only-mobile) {
    padding-bottom: var(--space-400);
  }
`;
